import { Component, Inject, Input, OnInit } from 'angular-ts-decorators';

import { ProductComparisonBaseComponent } from '../models/product-comparison-base.component';

import { getProductIds } from '../utils/get-product-ids';

import template from './product-comparison.component.html';

@Component({
  selector: 'productComparison',
  template,
  transclude: {
    empty: '?productComparisonEmpty',
    headline: '?productComparisonHeadline',
  },
})
export class ProductComparisonComponent extends ProductComparisonBaseComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input('@') public configurationId?: string;

  constructor(@Inject('$q') $q: ng.IQService) {
    super($q);
  }

  public ngOnInit() {
    const familyIds: number[] = getProductIds().map(Number);
    this.setFemilies(familyIds)
      .then(this.getAttributes.bind(this), this.stopLoading)
      .then(this.getSegmentTypeConfiguration.bind(this), this.stopLoading)
      .finally(this.stopLoading);
  }
}
